import { render } from "./OfficeCalendar.vue?vue&type=template&id=0c5c01c6&scoped=true"
import script from "./OfficeCalendar.vue?vue&type=script&lang=js"
export * from "./OfficeCalendar.vue?vue&type=script&lang=js"

import "./OfficeCalendar.vue?vue&type=style&index=0&id=0c5c01c6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c5c01c6"]])

export default __exports__